<span class="mat-content" [class.mat-content-hide-toggle]="!_showToggle()">
  <ng-content select="mat-panel-title"></ng-content>
  <ng-content select="mat-panel-description"></ng-content>
  <ng-content></ng-content>
</span>

@if (_showToggle()) {
  <span [@indicatorRotate]="_getExpandedState()" class="mat-expansion-indicator"></span>
}
